<router-outlet></router-outlet>
<app-information-panel></app-information-panel>

<div *ngIf="routeLoading()" class="route-loading" role="status" aria-live="polite" aria-label="Loading page">
  <div class="text-secondary">Loading page...</div>
  <div class="progress progress-sm">
    <div class="progress-bar progress-bar-indeterminate"></div>
  </div>
</div>

<div
  *ngIf="backendOffline()"
  class="backend-offline-banner"
  role="status"
  aria-live="assertive"
>
  <i class="ti ti-wifi-off" aria-hidden="true"></i>
  <span>The system is offline. We’ll reconnect automatically.</span>
  <button type="button" class="btn btn-sm btn-ghost-light" (click)="retryBackend()">
    Retry
  </button>
</div>
